import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ThemeProvider } from './contexts/theme'
import { AudioProvider } from './contexts/audio'
import './index.css'

render(
  <ThemeProvider>
    <AudioProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AudioProvider>
  </ThemeProvider>,
  document.getElementById('root')
)
